// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy-wrapper {
  background-color: #fcfcfc;
  color: #2d3436;
  font-family: 'Inter', -apple-system, sans-serif;
  padding: 60px 20px;
  line-height: 1.7;
}

.policy-container {
  max-width: 1100px;
  margin: 0 auto;
}

.back-link {
  background: none;
  border: none;
  color: #42b693;
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 40px;
  padding: 0;
  transition: opacity 0.2s;
}

.policy-header {
  margin-bottom: 60px;
  border-bottom: 1px solid #eee;
  padding-bottom: 30px;
}

.policy-badge {
  display: inline-block;
  background: rgba(66, 182, 147, 0.1);
  color: #42b693;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 15px;
}

.policy-title {
  font-size: 42px;
  font-weight: 800;
  letter-spacing: -1px;
  margin: 0 0 10px 0;
}

.policy-updated {
  color: #b2bec3;
  font-size: 14px;
}

.policy-grid {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 60px;
}

.policy-nav {
  position: sticky;
  top: 40px;
  height: fit-content;
}

.policy-nav ul {
  list-style: none;
  padding: 0;
}

.policy-nav li {
  margin-bottom: 15px;
}

.policy-nav a {
  text-decoration: none;
  color: #636e72;
  font-weight: 500;
  font-size: 15px;
  transition: color 0.2s;
}

.policy-nav a:hover {
  color: #42b693;
}

.policy-block {
  margin-bottom: 50px;
}

.policy-block h2 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
}

.data-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

.data-list span {
  background: #f1f2f6;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
}

.guarantee-box {
  background: #f8fff9;
  border-left: 4px solid #42b693;
  padding: 20px;
  margin: 20px 0;
  border-radius: 0 8px 8px 0;
}

.policy-footer {
  margin-top: 80px;
  padding-top: 30px;
  border-top: 1px solid #eee;
  font-style: italic;
  color: #636e72;
}

@media (max-width: 900px) {
  .policy-grid {
    grid-template-columns: 1fr;
  }
  .policy-nav {
    display: none;
  }
  .policy-title {
    font-size: 32px;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".policy-wrapper {\n  background-color: #fcfcfc;\n  color: #2d3436;\n  font-family: 'Inter', -apple-system, sans-serif;\n  padding: 60px 20px;\n  line-height: 1.7;\n}\n\n.policy-container {\n  max-width: 1100px;\n  margin: 0 auto;\n}\n\n.back-link {\n  background: none;\n  border: none;\n  color: #42b693;\n  cursor: pointer;\n  font-weight: 500;\n  margin-bottom: 40px;\n  padding: 0;\n  transition: opacity 0.2s;\n}\n\n.policy-header {\n  margin-bottom: 60px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 30px;\n}\n\n.policy-badge {\n  display: inline-block;\n  background: rgba(66, 182, 147, 0.1);\n  color: #42b693;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-bottom: 15px;\n}\n\n.policy-title {\n  font-size: 42px;\n  font-weight: 800;\n  letter-spacing: -1px;\n  margin: 0 0 10px 0;\n}\n\n.policy-updated {\n  color: #b2bec3;\n  font-size: 14px;\n}\n\n.policy-grid {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  gap: 60px;\n}\n\n.policy-nav {\n  position: sticky;\n  top: 40px;\n  height: fit-content;\n}\n\n.policy-nav ul {\n  list-style: none;\n  padding: 0;\n}\n\n.policy-nav li {\n  margin-bottom: 15px;\n}\n\n.policy-nav a {\n  text-decoration: none;\n  color: #636e72;\n  font-weight: 500;\n  font-size: 15px;\n  transition: color 0.2s;\n}\n\n.policy-nav a:hover {\n  color: #42b693;\n}\n\n.policy-block {\n  margin-bottom: 50px;\n}\n\n.policy-block h2 {\n  font-size: 22px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.data-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.data-list span {\n  background: #f1f2f6;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.guarantee-box {\n  background: #f8fff9;\n  border-left: 4px solid #42b693;\n  padding: 20px;\n  margin: 20px 0;\n  border-radius: 0 8px 8px 0;\n}\n\n.policy-footer {\n  margin-top: 80px;\n  padding-top: 30px;\n  border-top: 1px solid #eee;\n  font-style: italic;\n  color: #636e72;\n}\n\n@media (max-width: 900px) {\n  .policy-grid {\n    grid-template-columns: 1fr;\n  }\n  .policy-nav {\n    display: none;\n  }\n  .policy-title {\n    font-size: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
